import { __awaiter } from "tslib";
import ApiManager from '@/managers/apimanagers';
import { useStore } from '@/store/store';
import { key } from './auth';
/**
 * @summary ユーザー設定情報取得
 */
export const useSettings = () => {
    const store = useStore();
    /**
     * @returns ユーザー設定情報の設定
     */
    const setUserSettings = () => __awaiter(void 0, void 0, void 0, function* () {
        const url = '/user/settings';
        if (!localStorage.getItem(key)) {
            store.state.userSettings.isSound = localStorage.getItem('cryptos.sound') === 'true';
            store.state.userSettings.language = localStorage.getItem('cryptos.language') || 'English';
            return;
        }
        const settings = yield ApiManager.get(url).catch(() => {
            store.state.userSettings.isSound = localStorage.getItem('cryptos.sound') === 'true';
            store.state.userSettings.language = localStorage.getItem('cryptos.language') || 'English';
            return null;
        });
        if (settings !== null) {
            store.state.userSettings = settings;
        }
    });
    /**
     * @returns ユーザー設定全体の更新
     */
    const putUserSettings = (settings) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const url = '/user/settings';
            const body = Object.assign({}, settings);
            yield ApiManager.put(url, body);
        }
        catch (err) {
            throw err;
        }
    });
    return { setUserSettings, putUserSettings };
};
